var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"mt-3 px-3 loading"},[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12"}},[_c('v-card-text',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"size":150,"width":10,"indeterminate":"","color":"#0299B7"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }